import styled from 'styled-components';

export const Wrapper = styled.div`
  border-radius: ${({ theme }) => theme.rounded.x3};
  overflow: hidden;
`;

export const Footer = styled.div`
  background: ${({ theme }) => theme.palette.whiteGray};
  padding: ${({ theme }) => `${theme.spacing.x4} ${theme.spacing.x3}`};
  @media (max-width: ${({ theme }) => theme.media.md}) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;
export const Passengers = styled.div`
  display: flex;
  margin: ${({ theme }) => `${0} -${theme.spacing.x1} ${theme.spacing.x2}`};
`;

export const Passenger = styled.span`
  font-size: ${({ theme }) => theme.fs.xs};
  color: ${({ theme }) => theme.palette.lightText};
  font-weight: 500;
  padding: 0 ${({ theme }) => theme.spacing.x1};
`;

export const AmountTitle = styled.span`
  font-size: ${({ theme }) => theme.fs.md};
  color: ${({ theme }) => theme.palette.lightText};
  font-weight: 700;
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;

export const AmountWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 -${({ theme }) => theme.spacing.x2};
`;
export const AmountBox = styled.span`
  padding: 0 ${({ theme }) => theme.spacing.x2};
`;

export const Amount = styled.span`
  font-size: ${({ theme }) => theme.fs.md};
  font-weight: 700;
  color: ${({ theme }) => theme.palette.primary};
`;
export const AmountSuffix = styled.span`
  font-size: ${({ theme }) => theme.fs.xxs};
  font-weight: 400;
  color: ${({ theme }) => theme.palette.primary};
  padding-inline-start: ${({ theme }) => theme.spacing.x2};
  vertical-align: super;
`;
